import { normalizeSnakeToCamelCase } from '@caudena/core/utils/normalizeSnakeToCamelCase'
import http from '@caudena/core/http'
import { SettingsProfileCRMRaw, SettingsRaw } from '@caudena/api/endpoint'
import { getConfig } from '@caudena/core/useConfig'

export class SettingsService {
  public getSettingsProfile = async () => {
    const {
      data: { data },
    } = await http.get<{
      data: SettingsProfileCRMRaw
    }>(`${getConfig().COMPLIANCE_API}/api/settings/profile`)
    return normalizeSnakeToCamelCase(data)
  }
  public getSettings = async () => {
    const {
      data: { data },
    } = await http.get<{
      data: SettingsRaw
    }>(`${getConfig().COMPLIANCE_API}/api/settings`)
    return normalizeSnakeToCamelCase(data)
  }
}
